import React, { useState } from 'react';
import Input from '@ui-library/input';
import Modal from '@ui-library/modal/custom';
import ErrorLabel from '@ui-library/errorLabel';
import { Body } from '@ui-library/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import classes from './password.module.scss';

interface Props {
  submit: (password: string) => void;
  cancel: () => void;
  error: string | null;
  loading: boolean;
}

export default ({ submit, cancel, error, loading }: Props) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = () => {
    submit(password);
  };

  const handleCancel = () => {
    cancel();
  };
  return (
    <Modal
      title="Verify it's you"
      content={
        <>
          <Body className="m-b-md">Enter your password to continue.</Body>
          <Input
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Enter password"
            onPressEnter={handleSubmit}
            autoFocus
            suffix={
              <FontAwesomeIcon
                className={`${classes.svgIcon} ${password.length === 0 ? classes.icon : ''}`}
                onClick={() => setShowPassword(!showPassword)}
                icon={showPassword ? regular('eye-slash') : regular('eye')}
              />
            }
          />
          <ErrorLabel error={!!error} errorMessage={error || ''} />
        </>
      }
      onClose={handleCancel}
      onSave={handleSubmit}
      loading={loading}
      saveLabel="Continue"
      showClose
      size="md"
    />
  );
};
